
function definirNomeAndamentosTipos(id){

  const NomeAndamentosTiposApp = {
    1: 'Aberta',
    4: 'Atendida',
    46: 'No local',
    47: 'Não Atendida',
    49: 'Despachada',
    50: 'Reinterada',
    51: 'Cancelada',
    52: 'Fechada Atendida',
    53: 'Devolvida',
    54: 'Reclassificada',
    55: 'Aceita',
    66: 'Fechada Não Atendida'
  };
  return NomeAndamentosTiposApp[id];
}
function definirNomeAndamentosTiposPorSituacao(situacao){

  const NomeAndamentosTiposApp = {
    'Abrir': 'Aberta',
    'Atender': 'Atendida',
    'No local': 'No local',
    'Não Atender': 'Não Atendida',
    'Despachar': 'Despachada',
    'Reinterar': 'Reinterada',
    'Cancelar': 'Cancelada',
    'Fechar': 'Fechada Atendida',
    'Fechar Não Atender': 'Fechada Não Atendida',
    'Devolver': 'Devolvida',
    'Reclassificar': 'Reclassificada',
    'Aceitar': 'Aceita'
  };
  return NomeAndamentosTiposApp[situacao];
}
export { definirNomeAndamentosTipos, definirNomeAndamentosTiposPorSituacao};



// WEBPACK FOOTER //
// ./src/app/shared/utils/definir_nome_andamentos_tipo.ts